import { Phone, MapPin } from "lucide-react";

const WA_URL  = "https://wa.me/51932049397";
const FB_URL  = "https://www.facebook.com/profile.php?id=61568596892252";

const navLinks = [
  { href: "#inicio",       label: "Inicio" },
  { href: "#terapias",     label: "Terapias" },
  { href: "#evaluaciones", label: "Evaluaciones" },
  { href: "#equipo",       label: "Equipo" },
  { href: "#contacto",     label: "Contacto" },
];

function scrollTo(href) {
  const el = document.querySelector(href);
  if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 76, behavior: "smooth" });
}

export default function Footer() {
  return (
    <footer className="bg-navy text-white" role="contentinfo">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 pt-14 pb-8">

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-10 mb-12">

          {/* Brand */}
          <div>
            <a
              href="#inicio"
              onClick={(e) => { e.preventDefault(); scrollTo("#inicio"); }}
              aria-label="CIND – Inicio"
              className="inline-block mb-4"
            >
              <img
                src="/logo.png"
                alt="CIND – Centro Integral del Neurodesarrollo"
                className="h-10 w-auto object-contain brightness-0 invert"
                onError={(e) => {
                  e.target.style.display = "none";
                  e.target.nextSibling.style.display = "block";
                }}
              />
              <span
                className="hidden font-serif font-bold text-2xl text-white"
                aria-hidden="true"
              >
                CIND
              </span>
            </a>

            <p className="font-sans text-sm text-white/65 leading-relaxed max-w-xs">
              Centro Integral del Neurodesarrollo. Especialistas en diagnóstico
              y terapia para niños, adolescentes y adultos en Arequipa, Perú.
            </p>

            {/* Social icons */}
            <div className="flex gap-3 mt-5">
              <a
                href={FB_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook de CIND (abre en nueva pestaña)"
                className="w-9 h-9 rounded-lg bg-[#1877F2] flex items-center justify-center hover:bg-[#1565D8] transition-colors"
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="white" aria-hidden="true">
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
                </svg>
              </a>
              <a
                href={WA_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp de CIND (abre en nueva pestaña)"
                className="w-9 h-9 rounded-lg bg-[#25D366] flex items-center justify-center hover:bg-[#1ebe5d] transition-colors"
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" width="15" height="15" aria-hidden="true">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
                </svg>
              </a>
            </div>
          </div>

          {/* Navigation */}
          <nav aria-label="Navegación del pie de página">
            <h3 className="font-sans text-xs font-semibold tracking-widest uppercase text-white/50 mb-4">
              Navegación
            </h3>
            <ul className="flex flex-col gap-2.5">
              {navLinks.map(({ href, label }) => (
                <li key={href}>
                  <a
                    href={href}
                    onClick={(e) => { e.preventDefault(); scrollTo(href); }}
                    className="font-sans text-sm text-white/65 hover:text-white transition-colors"
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          {/* Contact */}
          <address className="not-italic">
            <h3 className="font-sans text-xs font-semibold tracking-widest uppercase text-white/50 mb-4">
              Contacto
            </h3>
            <ul className="flex flex-col gap-4">
              <li className="flex items-start gap-3">
                <Phone size={15} className="text-sage mt-0.5 flex-shrink-0" aria-hidden="true" />
                <div className="flex flex-col gap-1">
                  <a href="tel:+51932049397" className="font-sans text-sm text-white/70 hover:text-white transition-colors">
                    +51 932 049 397
                  </a>
                  <a href="tel:+51984246723" className="font-sans text-sm text-white/70 hover:text-white transition-colors">
                    +51 984 246 723
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={15} className="text-sage mt-0.5 flex-shrink-0" aria-hidden="true" />
                <span className="font-sans text-sm text-white/70 leading-relaxed">
                  Pasaje Felisa Moscoso 102,<br />Arequipa, Perú
                </span>
              </li>
            </ul>
          </address>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-sans text-xs text-white/40 text-center sm:text-left">
            © {new Date().getFullYear()} CIND – Centro Integral del Neurodesarrollo. Todos los derechos reservados.
          </p>
          <p className="font-sans text-xs text-white/30">Arequipa, Perú</p>
        </div>
      </div>
    </footer>
  );
}
